import React from 'react';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { ProgressContainer } from './style';

function CircleProgress(props: CircularProgressProps & { value: number }) {
    return (
        <Box
            position="relative"
            display="flex"
            alignItems="center"
            justifyContent="center"
            width={80}
            height={80}>
            <ProgressContainer>
                <CircularProgress variant="determinate" {...props} />
            </ProgressContainer>
            <ProgressContainer>
                <CircularProgress
                    variant="determinate"
                    {...props}
                    value={100}
                    style={{ color: 'rgba(255, 255, 255, 0.1)' }}
                />
            </ProgressContainer>
            <Typography variant="h5" component="div">{`${Math.round(props.value)}%`}</Typography>
        </Box>
    );
}

export default CircleProgress;
